// A score at or below the tenant's threshold is a bad score (e.g. stars <= 3,
// NPS <= 6, emoji bottom 2, thumbs down) and opens the low-score screen.
export const isLowScore = (score, threshold) => threshold !== null && score !== null && score <= threshold;

export const isLowScoreFormValid = (lowScore, { reasons, answers, comment }) => {
  if (lowScore.reasonsEnabled && lowScore.reasonsMandatory && lowScore.reasons.length > 0 && reasons.length === 0) {
    return false;
  }
  const missingAnswer = lowScore.questionsEnabled && lowScore.questions
    .some((question, index) => question.mandatory && !(answers[index] || '').trim());
  if (missingAnswer) return false;
  return !(lowScore.commentMandatory && !comment.trim());
};
